h2.g-user-otp-heading-enable Two-factor authentication is currently enabled

h3.g-user-otp-heading-disable Disable Two-factor authentication

button#g-user-otp-disable.btn.btn-primary(type="submit")
  |  Disable
